import React from 'react';
import Home from 'templates/Home';

const App = () => (
  <Home />
);

export default App;
